(function () {
  if (window.boostNoResultsEnhancementInitialized) return;
  window.boostNoResultsEnhancementInitialized = true;

  var noResultsSelector =
    '.boost-pfs-search-suggestion-no-result p, .product-list-no-search-result-text';
  var promptPattern =
    /Can't find what you're looking for\?\s*(?:Try|Use) our AI shopping assistant\.?/;
  var inlineAssistantPattern = /use our AI Shopping Assistant\.?/i;

  function enhanceElement(element) {
    if (element.querySelector('.ai-shopping-assistant-button, .ai-shopping-assistant-inline-link')) {
      return;
    }

    if (
      element.closest('.boost-pfs-search-suggestion-no-result') &&
      inlineAssistantPattern.test(element.textContent)
    ) {
      element.innerHTML = element.innerHTML.replace(
        inlineAssistantPattern,
        '<a class="ai-shopping-assistant-inline-link" href="/pages/ai-assistant">' +
          'use our AI Shopping Assistant' +
          '</a>.'
      );
      return;
    }

    if (!promptPattern.test(element.textContent)) return;

    element.innerHTML = element.innerHTML.replace(
      promptPattern,
      '<span class="ai-shopping-assistant-prompt">Can\'t find what you\'re looking for?</span>' +
        '<a class="ai-shopping-assistant-button" href="/pages/ai-assistant">' +
        'Use our AI shopping assistant' +
        '</a>'
    );
  }

  function enhanceWithin(root) {
    if (root.nodeType !== Node.ELEMENT_NODE) return;

    if (root.matches(noResultsSelector)) enhanceElement(root);
    root.querySelectorAll(noResultsSelector).forEach(enhanceElement);
  }

  function initBoostNoResultsEnhancement() {
    document.querySelectorAll(noResultsSelector).forEach(enhanceElement);

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(enhanceWithin);
      });
    }).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBoostNoResultsEnhancement);
  } else {
    initBoostNoResultsEnhancement();
  }
})();
